export const V3ChannelEvent = {
  ACTIVITY: 'workview_v3:activity',
  AUTOMATION_ACTION: 'workview_v3:automation_action',
  PAUSE: 'workview_v3:pause',
  UNPAUSE: 'workview_v3:unpause',
  TIME: 'workview_v3:time',
} as const

export type V3ChannelEvent = (typeof V3ChannelEvent)[keyof typeof V3ChannelEvent]
